module.exports = __webpack_public_path__ + "img/operation1.3f7f107b.png";